import React, { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { TitleTooltip, CellPrimaryText, TitleCellHoverGroup } from './styles';

const TruncatedTitleCell = ({ text }) => {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });

  useLayoutEffect(() => {
    const checkTruncation = () => {
      const el = textRef.current;
      if (!el) return;
      setIsTruncated(el.scrollWidth > el.clientWidth);
    };
    checkTruncation();
    window.addEventListener('resize', checkTruncation);
    return () => window.removeEventListener('resize', checkTruncation);
  }, [text]);

  const handleMouseEnter = () => {
    if (!isTruncated || !textRef.current) return;
    const rect = textRef.current.getBoundingClientRect();
    setCoords({ top: rect.top - 8, left: rect.left }); // 8px gap above
    setIsHovered(true);
  };

  const handleMouseLeave = () => setIsHovered(false);

  return (
    <TitleCellHoverGroup onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <CellPrimaryText ref={textRef}>{text}</CellPrimaryText>
      {isHovered &&
        isTruncated &&
        createPortal(
          <TitleTooltip
            style={{
              top: coords.top,
              left: coords.left,
              transform: 'translateY(-100%)', // sit above the row
            }}
          >
            {text}
          </TitleTooltip>,
          document.body
        )}
    </TitleCellHoverGroup>
  );
};

export default TruncatedTitleCell;
